// effects/products.effects.ts
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, tap } from 'rxjs/operators'; // Import operators correctly
import { of } from 'rxjs';



import { Store } from '@ngrx/store';
import { ApiService } from 'src/app/shared/services/api.service';
import { CurrentProfileActions } from './profile.actions';
import { OutlineItem, ProjectItem, UserProfile } from 'src/app/shared/models/base.models';


@Injectable()
export class ProfileEffects {

  constructor(
    private actions$: Actions,
    private api: ApiService,
    private store: Store
  ) {

  }


  loadProjects$ = createEffect(() =>
  this.actions$.pipe(
    ofType(CurrentProfileActions.load), // Listen for the loadProducts action
    mergeMap(() =>
      this.api.getProfile().pipe( // Use pipe method correctly within mergeMap
        map((response: UserProfile) => CurrentProfileActions.loadSuccess({ profile: response })),
        catchError((error) => of(CurrentProfileActions.loadFailure({ error }))
      )
    )
  )
));


}
